import { LocationSearchAddress } from './LocationSearchAddress';
import { LocationSearchAddressesList } from './LocationSearchAddressesList';
import { LocationSearchPredictionAddressesList } from './LocationSearchPredictionAddressesList';
import { LocationSearchScrollView } from './LocationSearchScrollView';

export const Location = {
  SearchAddress: LocationSearchAddress,
  SearchAddressesList: LocationSearchAddressesList,
  SearchPredictionAddressesList: LocationSearchPredictionAddressesList,
  SearchScrollView: LocationSearchScrollView,
};
